import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ProjectDetailPage } from "@/features/food-projects/project-detail-page";
import { PROJECT_TAB_VALUES, type ProjectTabValue } from "@/features/food-shared/constants";
import type { FoodBenchmarkId, FoodProjectId } from "@brewbase/db/types";

export const Route = createFileRoute("/food-app/projects/$project_id/")({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab?: ProjectTabValue; benchmarkId?: FoodBenchmarkId } => ({
    tab: PROJECT_TAB_VALUES.includes(search.tab as ProjectTabValue)
      ? (search.tab as ProjectTabValue)
      : undefined,
    benchmarkId: typeof search.benchmarkId === "number" ? search.benchmarkId as FoodBenchmarkId : undefined,
  }),
});

function RouteComponent() {
  const { project_id } = Route.useParams();
  const { tab, benchmarkId } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ProjectDetailPage
      projectId={project_id as FoodProjectId}
      tab={tab ?? "sessions"}
      activeBenchmarkId={benchmarkId}
      onTabChange={(value) =>
        navigate({
          to: ".",
          search: { tab: value === "sessions" ? undefined : (value as ProjectTabValue) },
          replace: true,
        })
      }
    />
  );
}
